const ProfessorTemplate = `⊕研究領域⊕


▲教授風格▲
(教授是否親自帶 ..)


★碩論題目與規劃★
(自己想、教授提供、目前實驗室的研究計畫）


◆畢業門檻◆


@修業年限@


▼畢業出路▼


＆適合怎麼樣的人＆


￠最後想說的話￠


￥其他￥
`

export default ProfessorTemplate;